// Web has no hardware device id to lean on (unlike mobile's getAndroidId()/
// getIosIdForVendorAsync() — see NLP/src/utils/deviceId.ts). This generates a random UUID once
// per browser and persists it in localStorage — stable across reloads/tabs of the SAME browser
// (localStorage is shared per-origin, so multiple tabs never falsely collide), but distinct
// across different browsers/machines/incognito windows. Sent on every login so the backend's
// one-web-session conflict check (AuthController.HasConflictingSessionAsync) can tell "same
// browser re-logging in" apart from "a second browser/device signing in" — see
// Models/Entities/UserSession.cs.
const STORAGE_KEY = "nlp_web_device_id";

export function getWebDeviceId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
  } catch (e) {
    // localStorage unavailable (private mode edge cases) — fall through to an ephemeral id below.
  }

  const fresh =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;

  try {
    localStorage.setItem(STORAGE_KEY, fresh);
  } catch (e) {
    // Best-effort persistence — a fresh id will be generated again next call if this failed.
  }

  return fresh;
}
